import React, { useEffect, useState, useMemo } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Field } from 'redux-form'
import { renderSelectField } from './fieldRenderers'
import { CURRENTMONTHINDEX, CURRENTYEAR, MESES } from '../../config/aniomeses'
import { Button } from '@material-ui/core'

function SelectedAnioMes (props) {
  const { handleSubmit, disabledFuture = true, change: formChange } = props
  const [selectedAnio, setSelectedAnio] = useState(CURRENTYEAR)
  const [selectedMes, setSelectedMes] = useState(MESES[CURRENTMONTHINDEX])
  const [init, setInit] = useState(false)

  useEffect(() => {
    if (formChange && !init) {
      formChange('year', CURRENTYEAR)
      setSelectedAnio(CURRENTYEAR)
      formChange('month', MESES[CURRENTMONTHINDEX])
      setSelectedMes(MESES[CURRENTMONTHINDEX])
      setInit(true)
    }
  }, [formChange, setInit, init])

  const handleAnioChange = (e, newValue) => {
    const anioParsed = parseInt(newValue, 10)
    setSelectedAnio(anioParsed)

    if (disabledFuture && anioParsed === CURRENTYEAR) {
      const mesActualIndex = MESES.indexOf(selectedMes)
      if (mesActualIndex > CURRENTMONTHINDEX) {
        setSelectedMes('')
        if (formChange) formChange('month', '')
      }
    }
  }

  const handleMesChange = (e, newValue) => {
    setSelectedMes(newValue)
  }

  const anioOptions = useMemo(() => {
    const options = []
    const yearsBack = 15
    for (let i = 0; i <= yearsBack; i++) {
      const year = CURRENTYEAR - i
      options.push(<option value={year} key={year}>{year}</option>)
    }
    return [<option value='' key='none'>Seleccione Año</option>, ...options]
  }, [])

  const mesOptions = useMemo(() => {
    let mesesDisponibles = MESES
    if (disabledFuture && parseInt(selectedAnio, 10) === CURRENTYEAR) {
      mesesDisponibles = MESES.slice(0, CURRENTMONTHINDEX + 1)
    }

    const options = mesesDisponibles.map((mes) => (
      <option value={mes} key={mes}>{mes}</option>
    ))
    return [<option value='' key='none'>Seleccione Mes</option>, ...options]
  }, [selectedAnio, disabledFuture])

  return (
    <Row style={{ alignItems: 'center', justifyContent: 'center' }} className='my-3'>
      <Col md={3}>
        <Field
          name='year'
          label='Año'
          component={renderSelectField}
          onChange={handleAnioChange}
          props={{ value: selectedAnio }}
          aria-label='Seleccionar año'
        >
          {anioOptions}
        </Field>
      </Col>

      <Col md={3}>
        <Field
          name='month'
          label='Mes'
          component={renderSelectField}
          onChange={handleMesChange}
          props={{ value: selectedMes }}
          disabled={!selectedAnio}
          aria-label='Seleccionar mes'
        >
          {mesOptions}
        </Field>
      </Col>

      <Col md={2}>
        <Button
          variant='contained'
          onClick={handleSubmit}
          color='primary'
          fullWidth
          disabled={!(selectedAnio && selectedMes)}
          style={{ marginTop: '16px' }}
        >
          Consultar
        </Button>
      </Col>
    </Row>
  )
}

export default SelectedAnioMes
